var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isWelcomeBlock)?_c('WelcomeBlock',{on:{"open-appointment":_vm.showAppointmentBlock}}):_c('AppointmentBlock',{attrs:{"user-id":_vm.userInfo.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }